import React, { useState, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';

import { Link } from '@remix-run/react';
import { motion } from 'framer-motion';

const CallToAction = () => {
	const { userIsLoggedIn } = useLoaderData();

	const [totalSales, setTotalSales] = useState<number>(2304);

	const orderValue = [19.99, 34.99, 49.99, 39.89, 59.97, 24.99];

	const getRandomOrderValue = () => {
		const randomIndex = Math.floor(Math.random() * orderValue.length);
		return parseFloat(orderValue[randomIndex].toFixed(2));
	};

	const formatTotalSales = (value: number) => {
		if (value >= 1000) {
			return (value / 1000).toFixed(2) + 'K';
		}
		return value.toFixed(2);
	};

	useEffect(() => {
		const interval = setInterval(() => {
			setTotalSales(prev => prev + getRandomOrderValue());
		}, 2500);
		return () => clearInterval(interval);
	});

	return (
		<section className="-mb-20 mt-6 px-6">
			<div className="bg-transparent mx-auto grid w-full max-w-[1400px] flex-col items-center gap-10 overflow-hidden bg-[#050520] backdrop-blur-xl md:grid-cols-2 md:pt-20">
				<div className="relative order-2 mx-auto max-w-[425px] sm:order-1">
					<div className="absolute left-0 right-0 top-[calc(50%-40px)] mx-auto flex w-fit font-inter text-3xl font-semibold tracking-tight">
						<motion.p
							key={totalSales}
							initial={{ scale: 1, opacity: 1 }}
							animate={{ scale: [1, 1.3, 1], opacity: [1, 0.3, 1] }}
							transition={{ duration: 1, ease: 'easeInOut' }}>
							${formatTotalSales(totalSales)}
						</motion.p>
					</div>
					<img
						src="/images/landingpage/shopifyAppSales.svg"
						className="mx-auto w-full object-cover"
						alt="Shopify Conversion Optimization"
					/>
				</div>

				<div className="order-1 flex flex-col gap-6 sm:order-2">
					<div className="mt-6 flex flex-row items-center justify-center md:mt-0 md:justify-start">
						<div>
							<div className="flex flex-wrap items-center justify-center gap-1 text-sm font-light text-white lg:gap-3 lg:text-lg">
								<div className="flex lg:hidden">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
								</div>
								<div>
									<span className="hidden lg:inline-flex">Rated</span> "Excellent"{' '}
									<span className="font-bold">4.8/5</span>
								</div>
								<div className="hidden flex-row lg:flex">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
								</div>
								by our <span className="font-bold">1000+</span> successful dropshippers
							</div>
							<div className="mt-2 text-center text-white sm:text-left">
								Discover Why PagePilot is the Preferred Choice for Dropshippers.
							</div>
						</div>
					</div>

					<h2 className="relative items-center justify-center text-center text-4xl font-bold md:text-left lg:text-5xl">
						<span className="text-transparent bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
							Try PagePilot.ai{' '}
						</span>
						<span className="text-transparent bg-gradient-to-b from-white from-30% to-[#7496F8] bg-clip-text">
							risk-free{' '}
						</span>
					</h2>

					<ul className="flex flex-col">
						<li className="flex items-center">
							<svg className="h-4 w-4 fill-greenPrimary" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
								<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
							</svg>
							<span className="ml-3 text-lg text-gray-DEFAULT-400">Create product pages with a few clicks</span>
						</li>
						<li className="flex items-center">
							<svg className="h-4 w-4 fill-greenPrimary" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
								<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
							</svg>
							<span className="ml-3 text-lg text-gray-DEFAULT-400">Import products for AliExpress & Shopify</span>
						</li>
						<li className="flex items-center">
							<svg className="h-4 w-4 fill-greenPrimary" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
								<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
							</svg>
							<span className="ml-3 text-lg text-gray-DEFAULT-400">Get 10 winning product recommendations daily</span>
						</li>
					</ul>

					<div className="w-full max-w-[500px]">
						<Link
							prefetch="intent"
							className="btn-landing w-full max-w-full font-semibold"
							to={userIsLoggedIn ? '/list' : '/signup'}>
							Start Now For FREE
						</Link>
						<div className="mt-4 text-center text-slate-400">No credit card required</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CallToAction;
